<p-dialog 
  header="Customize Default Chat Responses"
  class="header"
  [(visible)]="showdialog"
  [modal]="true"
  [style]="{ width: '35vw', minWidth: '350px' }"
  [draggable]="false"
  [resizable]="false" (onHide)="onClose()"
>

  <!-- Loader -->
  <div *ngIf="isLoading" class="loader">
    <p-progressSpinner></p-progressSpinner>
  </div>

    <!-- Dynamic Text Areas -->
  <div *ngIf="!isLoading">
    <span class="flex justify-content-start queryStyle ">
      What should QIQ know about you?
    </span>
    <div class="textarea-container mt-3 mb-4">
      <textarea
        rows="4"
        cols="30"
        pInputTextarea
        placeholder="I'm a researcher in the field of AI.
                    I typically write code in Python.
                    I like approaching code architecture through domain modeling first.
                    In project planning, I tend to work backwards from the end goal."
        (ngModelChange)="onTextChangeDebounced()"
        [(ngModel)]="aboutUser[0]">
      </textarea>
    </div>
    <span class="flex justify-content-start queryStyle">
      What personal preferences should QIQ consider in responses?
    </span>
    <div class="textarea-container mt-3">
      <textarea
        rows="4"
        cols="30"
        pInputTextarea
        placeholder="When explaining new concepts, make use of analogies.
          When providing code, give detailed explanations.
          When working with image data, be expressive."
        (ngModelChange)="onTextChangeDebounced()"
        [(ngModel)]="customInstructions[0]">
      </textarea>
    </div>
    <div class="flex justify-content-start align-items-center">
      <span class="switch mr-2">
        <input type="checkbox" id="enableInstructionsToggle" [(ngModel)]="enableInstructions">
        <span class="slider"></span>
      </span>
      <label for="enableInstructionsToggle">Enable for new chats</label>
    </div>
  </div>

  <!-- Button Container -->
  <div *ngIf="!isLoading" class="footer">
    <div class="flex justify-end">
      <button label="Cancel" (click)="onClose()" class="p-button p-button-label mx-3">Cancel</button>
      <button label="Save" (click)="emitSummary()" class="p-button p-button-primary">Save</button>
    </div>
  </div>

</p-dialog>
